import { getApiConfig } from "@/lib/api/config";
import type { AuthMode } from "@/types/auth-types";

/**
 * Auth mode for the SPA.
 * - saml: redirect to backend GET /api/auth/saml/login (Azure SAML SSO)
 * - mock: local demo session
 * - backend: legacy fallback session endpoint
 */
export function getAuthMode(): AuthMode {
  const { authLoginUrl, useMock, baseUrl } = getApiConfig();

  if (authLoginUrl || (baseUrl && !useMock)) {
    return "saml";
  }

  if (useMock) return "mock";
  return "backend";
}

export function isSamlAuthEnabled(): boolean {
  return getAuthMode() === "saml";
}
